export const ADD_PAYMENT_METHOD = 'ADD_PAYMENT_METHOD'
export const ADD_GUEST_PAYMENT_METHOD = 'ADD_GUEST_PAYMENT_METHOD'

export const ADD_PAYMENT_METHOD_SUCCESS = 'ADD_PAYMENT_METHOD_SUCCESS'
export const REMOVE_CREDIT_CARD = 'REMOVE_CREDIT_CARD'
export const INIT_PAYMENT = 'INIT_PAYMENT'
export const PSP_VERIFICATION_RESPONSE = 'PSP_VERIFICATION_RESPONSE'
export const SECURE3D_RESPONSE = 'SECURE3D_RESPONSE'
export const SECURE3D_CANCELLED = 'SECURE3D_CANCELLED'
export const SET_DEFAULT_CREDIT_CARD = 'SET_DEFAULT_CREDIT_CARD'

export const GET_PSE_PAYMENT_BANKS = 'GET_PSE_PAYMENT_BANKS'
export const SET_PSE_PAYMENT_BANKS = 'SET_PSE_PAYMENT_BANKS'

export const PAYMENT_SUCCESS = 'PAYMENT_SUCCESS'
export const PAYMENT_CANCELLED = 'PAYMENT_CANCELLED'
export const PAYMENT_ERROR = 'PAYMENT_ERROR'

export const SET_PIX_QR_CODE_DATA = 'SET_PIX_QR_CODE_DATA'
